import { PhoneCall, CalendarCheck, Sparkles } from "lucide-react";
import { Reveal } from "./reveal";
import { openQuoteModal } from "./quote-modal";

const STEPS = [
  {
    icon: PhoneCall,
    step: "1",
    title: "Call or Request a Quote",
    body: "Tell us what you need cleaned. Most quotes are done remotely — no waiting around for a salesman.",
  },
  {
    icon: CalendarCheck,
    step: "2",
    title: "We Schedule It",
    body: "Pick a day that works for you. We confirm by text and show up when we say we will.",
  },
  {
    icon: Sparkles,
    step: "3",
    title: "Enjoy the Results",
    body: "A clean home you can be proud of — guaranteed. No mess left behind, no hassle.",
  },
];

export function HomeHowItWorks() {
  return (
    <section className="bg-[var(--brand-light-gray)] py-14 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4">
        <div className="text-center mb-9 md:mb-11">
          <p
            className="text-[var(--brand-red)] font-semibold uppercase tracking-[0.2em] text-sm mb-3"
            style={{ fontFamily: "var(--font-display)" }}
          >
            How It Works
          </p>
          <h2
            className="text-[var(--brand-deep-blue)] text-3xl md:text-4xl uppercase leading-tight"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            Call the Pros — We Handle the Rest
          </h2>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map(({ icon: Icon, step, title, body }, i) => (
            <Reveal
              as="li"
              key={step}
              delayMs={i * 90}


              className="card-pop relative flex h-full flex-col items-center text-center bg-white border border-gray-200 rounded-lg p-6 shadow-sm"
            >
              <span
                className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--brand-red)] text-white text-sm"
                style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
                aria-hidden="true"
              >
                {step}
              </span>
              <Icon
                className="icon-wiggle text-[var(--brand-deep-blue)] mt-3 mb-4"
                size={40}
                strokeWidth={1.75}
                aria-hidden="true"
              />
              <h3
                className="text-[var(--brand-deep-blue)] text-lg uppercase mb-2"
                style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
              >
                {title}
              </h3>
              <p className="text-[var(--brand-charcoal)] text-sm leading-relaxed">{body}</p>
            </Reveal>
          ))}
        </ol>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center">
          <button
            type="button"
            onClick={() => openQuoteModal()}
            className="btn-pop inline-flex items-center justify-center rounded-md bg-[var(--brand-red)] text-white px-7 py-4 uppercase tracking-wide hover:bg-[var(--brand-red-hover)] transition-colors min-h-[44px]"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            Get Free Quote
          </button>
          <a
            href="tel:+15189001913"
            className="btn-pop inline-flex items-center justify-center rounded-md bg-[var(--brand-deep-blue)] text-white px-7 py-4 uppercase tracking-wide hover:opacity-90 transition-opacity min-h-[44px]"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            Call (518) 900-1913
          </a>
        </div>
      </div>
    </section>
  );
}